import React from 'react';
import Modal from '../../../../../components/Modal';

export default function AllManagersModal({open, groupedManagers, loading, onClose, onCopyEmail}) {
  if (!open) return null;
  return (
    <Modal title="All Resource Managers" onClose={onClose} maxWidthClass="max-w-3xl">
      <div className="space-y-4">
        {loading ? (
          <div className="flex items-center justify-center py-6">
            <svg className="animate-spin h-6 w-6 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
          </div>
        ) : (
          <div className="space-y-4 max-h-[60vh] overflow-auto">
            {Array.from(groupedManagers.entries()).length === 0 ? (
              <div className="text-sm text-gray-500">No managers found.</div>
            ) : (
              Array.from(groupedManagers.entries()).map(([key, group]) => (
                <div key={key} className="border-b pb-3">
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-medium text-gray-800 dark:text-gray-100">{group.label || key}</div>
                    <div className="text-xs text-gray-500">{group.entries.length} manager(s)</div>
                  </div>
                  <div className="mt-2 space-y-2">
                    {group.entries.map((m, i) => (
                      <div key={i} className="flex items-center justify-between">
                        <div className="min-w-0 mr-3">
                          <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{m.manager_name || m.user_name || m.name || m.user || m.email || '—'}</div>
                          <div className="text-xs text-gray-500 truncate">{m.user_email || m.email || ''}</div>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300">{m.role}</span>
                          <button type="button" onClick={() => { onCopyEmail && onCopyEmail(m.user_email || m.email || ''); }} className="text-xs px-2 py-1 rounded-md border border-gray-200/70 dark:border-gray-600/70 bg-surface dark:bg-gray-870 text-gray-700 dark:text-gray-200 hover:bg-gray-50">Copy email</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}

